export const TOGGLE_MODAL_RESET_REQUEST = 'TOGGLE_MODAL_RESET_REQUEST';

export function toggleModalResetRequest() {
  return {
    type: TOGGLE_MODAL_RESET_REQUEST,
  };
}
